import React from 'react';
import { Loader2 } from 'lucide-react';

export const LoadingSpinner = () => (
    <div className="flex justify-center items-center p-10 h-full">
        <Loader2 className="animate-spin text-blue-600" size={40} />
        <p className="ml-4 text-lg text-gray-600">Đang tải dữ liệu...</p>
    </div>
);